export default "__VITE_ASSET__Bb0OG14b__"